const CONSTANTS = {
  PROJECT_ROUTES: {
    HOME: "/",
    LOGIN: "/login",
    RESET_PASSWORD: "/reset-password",
    LISTING: "/demand-forecast",
    LISTING_WITH_ID: "/demand-forecast/:id",
    STRUCTURE_VARIANTS: "/structure-varaints",
    ARCHIEVE: "/archive",
    OVERALL_SUMMARY: "/overall-summary",
    RISK_LOGIC: "/risk-logic",
    VIEW_ARCHIEVE: "/view-archive/:id",
    STRUCTURE_VARIANTS_WITH_ID: "/structure-varaints/:id",
    MANAGE_FILES: "/manage-files",
    REDIRECT: "/redirect/*",
    LOGOUT: "/logout",
    NO_ACCESS: "/no-access",
    DISPATCH_DATA: "/dispatch-data"
  },
  API_ROUTES: {},
};


export default CONSTANTS;

export const USD_TO_INR = 80;

export const PER_PAGE_FOR_ARCHIVE = 10;

export const TIMEZONE = "Asia/Kolkata";

export const COMMON_CONSTANT = {
  MAX_CONSENSUS_VALUE: 99999999.99,
  MAX_CONSENSUS_BREAKUP_VALUE: 99999999.99,
  MAX_CONSENSUS_NON_FRACTION_DIGITS: 8,
  MAX_CONSENSUS_FRACTION_DIGITS: 2, // after decimal
   // For Inventory in Transit (DECIMAL 12,3)
  MAX_INVENTORY_IN_TRANSIT_VALUE: 999999999.999,
  MAX_INVENTORY_IN_TRANSIT_NON_FRACTION_DIGITS: 9,
  MAX_INVENTORY_IN_TRANSIT_FRACTION_DIGITS: 3,

  // Price at the Time of Order (Rs/MT) – allow up to 9999999999.999
  MAX_ORDER_PRICE_VALUE: 9999999999.999,
  MAX_ORDER_PRICE_NON_FRACTION_DIGITS: 10,
  MAX_ORDER_PRICE_FRACTION_DIGITS: 3,

  // How Much to Order (MT) – allow up to 999999999.999
  MAX_ORDER_QUANTITY_VALUE: 999999999.999,
  MAX_ORDER_QUANTITY_NON_FRACTION_DIGITS: 9,
  MAX_ORDER_QUANTITY_FRACTION_DIGITS: 3,

  // Best Price Available Per MT – allow up to 999999999.999
  MAX_BEST_PRICE_VALUE: 9999999999.999,
  MAX_BEST_PRICE_NON_FRACTION_DIGITS: 10,
  MAX_BEST_PRICE_FRACTION_DIGITS: 3,

  MAX_MIN_LEAD_TIME: 12,


  MAX_CONSUMPTION_QUANTITY_VALUE: 999999999999.999,
  MAX_CONSUMPTION_QUANTITY_NON_FRACTION_DIGITS: 12,
  MAX_CONSUMPTION_QUANTITY_FRACTION_DIGITS: 3,
 
  ERROR_DEFICIT_VALUE: 0.001,
  LEVEL_1_MIN: 0,
  LEVEL_1_MAX: 0,
  LEVEL_2_MIN: 0.001,
  LEVEL_2_MAX: 30,
  LEVEL_3_MIN: 30.001,
  LEVEL_3_MAX: 60,
  LEVEL_4_MIN: 60.001,
  LEVEL_4_MAX: 100,
};

export const modalStyles = {
  container: {
    padding: "20px",
    maxWidth: "400px",
    margin: "0 auto",
  },
  label: {
    fontSize: "1.1rem",
    fontWeight: "600",
    color: "white",
    marginBottom: "10px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "10px",
    fontSize: "1rem",
    border: "1px solid rgb(225 216 216)",
    borderRadius: "4px",
    marginBottom: "20px",
    marginTop: "10px",
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.2s",
    backgroundColor: "rgb(225 216 216)",
  },
  inputFocus: {
    borderColor: "rgb(225 216 216)",
  },
  error: {
    color: "#dc3545",
    fontSize: "0.85rem",
    marginBottom: "15px",
  },
  button: {
    backgroundColor: "#242f6e",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    fontSize: "1rem",
    cursor: "pointer",
    width: "100%",
    transition: "background-color 0.2s",
  },
  buttonHover: {
    backgroundColor: "#0056b3",
  },
  buttonDisabled: {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
  },
};

export const machineMapping = {
  Calender: [
    { code: "CALN01", value: "Calender - 1000", label: "CAL 1000" },
    { code: "CALN02", value: "Calender - 2000", label: "CAL 2000" },
    { code: "", value: "Skip", label: "Skip" },
  ],
  Coater: [
    { code: "CTR01", value: "Coater - 1600", label: "Coater 1600" },
    { code: "CTR02", value: "Coater - 1650", label: "Coater 1650" },
    { code: "", value: "Skip", label: "Skip" },
  ],
  Laminator: [
    { code: "LAM01", value: "Laminator - LAM01", label: "LAM 01" },
    { code: "", value: "Skip", label: "Skip" },
  ],
  Slitter: [
    { code: "SLT01", value: "Slitter - SLT01", label: "Slitter 01" },
    { code: "SLT02", value: "TITAN 1 ", label: "TITAN 1 " },
    { code: "SLT03", value: "TITAN 2 ", label: "TITAN 2 " },
    { code: "SLT04", value: "SUPER RAULIMAX ", label: "SUPER RAULIMAX " },
    { code: "SLT05", value: "OLD GIANT ", label: "OLD GIANT" },
    { code: "SLT05", value: "SP ULTRAFLEX  ", label: "SP ULTRAFLEX " },
    { code: "", value: "Skip", label: "Skip" },
  ],
};


